import {ProductState} from "./product-state";

export const ProductStateLabel: { [key in ProductState]: string } = {
  [ProductState.PENDING]: 'Aangevraagd',
  [ProductState.INACTIVE]: 'Inactief',
  [ProductState.CANCELLED]: 'Geannuleerd',
  [ProductState.ACTIVE]: 'Actief',
  [ProductState.PENDING_TERMINATION]: 'Opzegging',
};
